import { RootState } from "store/store";
import Customers from "../Customers/Customers";
import { connect } from "react-redux";
import { fetchCustomers } from "store/customers/customers-thunks";
import { setActiveCustomerById } from "store/customers/customers-actions";
import { compose } from "redux";
import { getCustomersFilteredSelector } from "store/customers/customers-selectors";
import { getAppSettings } from "store/app-settings/app-settings-selectors";

const mapStateToProps = (state: RootState) => {
    return {
        filteredCustomers: getCustomersFilteredSelector(state),
        appSettings: getAppSettings(state),
        errorMessage: state.initializationReducer.errorResponseMessage,
    };
};
const CustomersContainer = compose(
    connect(mapStateToProps, {
        fetchCustomers,
        setActiveCustomerById,
    })
)(Customers);

export default CustomersContainer;
